import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { indexTemplateHtml, indexTemplateHtmlStatic } from './variables';
// tslint:disable-next-line:no-duplicate-string
import * as common from 'markdown-tip';
export * from 'markdown-tip';
var MarkdownTip = /** @class */ (function (_super) {
    tslib_1.__extends(MarkdownTip, _super);
    function MarkdownTip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visibleText = null;
        _this.titleClass = common.defaultTitleClass;
        return _this;
    }
    Object.defineProperty(MarkdownTip.prototype, "datas", {
        get: function () {
            return common.getLocale(this.locale);
        },
        enumerable: true,
        configurable: true
    });
    MarkdownTip.prototype.mouseenter = function (data, event) {
        this.visibleText = data.text;
        this.titleClass = common.getTitleClass(event.target);
    };
    MarkdownTip.prototype.mouseleave = function (data) {
        this.visibleText = null;
    };
    MarkdownTip = tslib_1.__decorate([
        Component({
            render: indexTemplateHtml,
            staticRenderFns: indexTemplateHtmlStatic,
            props: ['locale']
        })
    ], MarkdownTip);
    return MarkdownTip;
}(Vue));
export { MarkdownTip };
Vue.component('markdown-tip', MarkdownTip);
